import { Module } from '../api/module';

export const isStandaloneModule = (module?: Module) => {
  return module && !module.hasExerciseEntrance && !module.subModules.length;
};
